export function isEmpty(a: any) {
    return !a || a === ""
}

export function deepcopy(a: any) {
    let b: any = null;
    if (a && typeof a === 'object') {
        if (Array.isArray(a)) {
            b = [];
            a.forEach(aa => {
                b.push(deepcopy(aa));
            })
        } else {
            b = {};
            for (let key in a) {
                if (a.hasOwnProperty(key))
                    b[key] = deepcopy(a[key]);
            }
        }
    } else {
        b = a;
    }
    return b;
}

export function update(a: any, b: any) {
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (Array.isArray(a) && Array.isArray(b)) {
            a.splice(0, a.length);
            b.forEach(bb => {
                a.push(deepcopy(bb));
            })
        } else if (!Array.isArray(a) && !Array.isArray(b)) {
            for (let key in b) {
                if (a[key] !== undefined) {
                    if (b[key] === null) {
                        a[key] = null;
                    } else if (Array.isArray(a[key]) && Array.isArray(b[key])) {
                        update(a[key], b[key]);
                    } else if (typeof a[key] === 'object' && typeof b[key] === 'object' && a[key] !== null) {
                        update(a[key], b[key])
                    } else if (typeof a[key] !== 'object' && typeof b[key] !== 'object') {
                        a[key] = b[key];
                    } else if (typeof b[key] !== 'object' && a[key] === null) {
                        a[key] = b[key];
                    }
                }
            }
        }
    }
}
